import notification from '@common/components/notification/notification.component';
import { EnumNotificationPlacement } from '@common/components/notification/enums/notificationPlacement.enum';

export default {
  copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {
      notification.showSuccess({
                      description: 'Texto copiado para a área de transferência',
                      placement: EnumNotificationPlacement.BottomRight,
                      duration: 2
                    });
    }).catch((err) => {
      notification.showError({
        description: `Falha ao copiar o texto: ${err}`,
        placement: EnumNotificationPlacement.BottomRight,
        duration: 2
      });
    });
  }
};
